const historyRecordMap = new Map([
  ['list', '/tenant/history']
]);

export default historyRecordMap;
